import { render, staticRenderFns } from "./PurchaseOrderForm.vue?vue&type=template&id=54210b0c&scoped=true"
import script from "./PurchaseOrderForm.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderForm.vue?vue&type=style&index=0&id=54210b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54210b0c",
  null
  
)

export default component.exports